export const FD_PROXY = '/proxy/first-data';
